// extracted by mini-css-extract-plugin
module.exports = {"errorStateRoot":"Tpfw6GYf","showBorder":"xNRutrvg","emailLink":"W3C3zYMF","errorSubtitle":"hZmPlgAJ","styledErrorMessage":"LcXzHihh"};